export default __webpack_public_path__ + "static/media/delivery-box-add-operation-03.006d5842.png";